/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import GatsbyConfig from "../../gatsby-config"

const { siteMetadata } = GatsbyConfig

const icon = siteMetadata.themeIcon
    ? require("../content/img/" + siteMetadata.themeIcon)
    : require("../content/img/etiqaicon.png")

function SEO({
    title = "Etiqa Insurance",
    description = "",
    lang = "en",
    meta = [],
    author = "@etiqa.com.sg",
}) {
    const metaDescription = description || siteMetadata.description || ""
    const siteTitle = siteMetadata.title || "Etiqa Insurance"
    const siteAuthor = siteMetadata.author || author

    return (
        <Helmet
            htmlAttributes={{ lang }}
            title={title}
            titleTemplate={`%s | ${siteTitle}`}
            meta={[
                {
                    name: `description`,
                    content: metaDescription,
                },
                {
                    property: `og:title`,
                    content: title,
                },
                {
                    property: `og:description`,
                    content: metaDescription,
                },
                {
                    property: `og:type`,
                    content: `website`,
                },
                {
                    name: `twitter:card`,
                    content: `summary`,
                },
                {
                    name: `twitter:creator`,
                    content: siteAuthor
                },
                {
                    name: `twitter:title`,
                    content: title,
                },
                {
                    name: `twitter:description`,
                    content: metaDescription,
                },
            ].concat(meta)}
        >
            <link rel="icon" href={icon} />
        </Helmet>
    )
}

SEO.propTypes = {
    description: PropTypes.string,
    lang: PropTypes.string,
    meta: PropTypes.arrayOf(PropTypes.object),
    title: PropTypes.string.isRequired,
}

export default SEO
